<template>
  <div class="thanks">
    <!-- TODO добавить переводы -->
    <div class="title">{{$ml.get('Thank you for purchase!')}}</div>
    <button @click="next" class="next h-empty-btn">
      Continue
    </button>
  </div>
</template>

<script>
export default {
  created() {
    this.sendGA();
  },
  methods: {
    sendGA() {

      const plan = this.$route.params.plan;

      if(plan === 'impact') {
        gtag('event', 'conversion', {'send_to': 'AW-764874558/S6S-CIuz_skBEL6e3OwC'});
        fbq('track', 'Purchase', {value: 22.29, currency: 'GBP', content_name:'Impact', content_category: 'Our Product' });
      }
      else if(plan === 'exact') {
        gtag('event', 'conversion', {'send_to': 'AW-764874558/hLz7CK61_skBEL6e3OwC'});
        fbq('track', 'Purchase', {value: 229.00, currency: 'GBP', content_name:'Exact', content_category: 'Our Product' });
      }
      else if(plan === 'premium') {
        gtag('event', 'conversion', {'send_to': 'AW-764874558/vdsICIK5_skBEL6e3OwC'});
        fbq('track', 'Purchase', {value: 529.00, currency: 'GBP', content_name:'Premium', content_category: 'Our Product' });
      }
      else if(plan === 'elite') {
        gtag('event', 'conversion', {'send_to': 'AW-764874558/5gHdCPbxjMoBEL6e3OwC'});
        fbq('track', 'Purchase', {value: 1999.00, currency: 'GBP', content_name:'Elite', content_category: 'Our Product' });
      }
    },
    next() {
      this.$router.push('/auth/quick/password');
    },
  }
}
</script>

<style lang="scss" scoped>

.thanks {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 100%;
  background: #fff;

  .title {
    font-size: 36px;
    font-weight: 600;
    width: 300px;
    text-align: center;
    padding-bottom: 50px;
  }

  .next {
    width: 200px;
    height: 50px;
    background: $mainGreen;
    border-radius: 9999px;
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    transition: box-shadow 0.3s ease, transform 0.3s ease;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 20px rgba($mainGreen, 0.8);
    }
  }
}

</style>
